import React, { useEffect, useState } from 'react'
import { components, constants, useServices } from 'cng-web-lib'
import pathMap from '../../../paths/pathMap'
import ResponseLog from '../manifest/ResponseLog'
import { Box, Grid } from '@material-ui/core'
import AceOcnBillofladingApiUrls from 'src/apiUrls/AceOcnBillofladingApiUrls'

const { button: { CngButton } } = components
const { filter: { EQUAL } } = constants

function ViewLogsHistory(props) {
  const { history, manifestId, onChangeStep, step } = props
  const { fetchRecords } = useServices()

  const [billofLadingEmpty, setBillofLadingEmpty] = useState(true);

  useEffect(() => {
    Promise.all([
      fetchRecords.execute(
        AceOcnBillofladingApiUrls.GET,
        { filters: [{ field: 'manifestId', operator: EQUAL, value: manifestId }] },
        (res) => res.content
      )
    ]).then(([billofLading]) => {
      setBillofLadingEmpty(billofLading && billofLading.length > 0 ? false : true);
    })
  }, []);

  return (
    <>
      <ResponseLog manifestId={manifestId}/>
      <Box marginTop={2}>
        <Grid container justify='space-between' spacing={3}>
          <Grid item xs={12} md='auto'>
            <CngButton
              color='secondary'
              onClick={() =>
                history.push(pathMap.ACE_OCN_MANIFEST_LIST_VIEW)
              }
              size='medium'
            >
              Discard
            </CngButton>
          </Grid>
          <Grid item xs={12} md='auto'>
            <Grid container spacing={2}>
              <Grid item xs='auto'>
                <CngButton color='secondary' onClick={() => onChangeStep(step - 1)} size='medium'>
                  Back
                </CngButton>
              </Grid>
              <Grid item xs='auto'>
                <CngButton
                  color='primary'
                  onClick={() => billofLadingEmpty ? onChangeStep(step - 3) : onChangeStep(step - 2)}
                  size='medium'>
                  Go to Submit
                </CngButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default ViewLogsHistory
